import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_CURRENT_REP_FETCH } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { currentRepAppointmentsListSchema } from '../../schemas/Normalizr';

export function* appointmentCurrentRepFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = {
    office_id: action.payload.office_id,
    start_date: action.payload.start_date,
    rep_id: action.payload.rep_id,
    'status[]': action.payload.status
  };

  try {
    yield *httpSaga(APPOINTMENT_CURRENT_REP_FETCH, call(appointmentAPI.all, params), currentRepAppointmentsListSchema);
  } catch (e) {
    yield put(error(APPOINTMENT_CURRENT_REP_FETCH, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_CURRENT_REP_FETCH));
  }
}

export function* watchAppointmentCurrentRepFetch() {
  yield takeEvery(APPOINTMENT_CURRENT_REP_FETCH, appointmentCurrentRepFetch);
}

export default function* root() {
  yield all([
    fork(watchAppointmentCurrentRepFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentCurrentRepFetch.js